import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {WidgetData} from '../../../../../../../core/shared/widget/widget-data';
import {WidgetFactory} from '../../../../../../../core/shared/widget/service/widget.factory';

@Component({
    selector: 'bm-customer-billing-transaction-type-details',
    templateUrl: 'bm-customer-billing-transaction-type-details.component.html',
    standalone: false
})
export class BmCustomerBillingTransactionTypeDetailsComponent implements OnInit, OnChanges, OnDestroy {

    initialized: boolean = false;

    @Input() customerBillingTransactionTypeId: number;

    customerBillingTransactionTypeWidgetData: WidgetData;

    ngOnInit(): void {
        this.refreshComponent();
    }

    refreshComponent() {
        this.customerBillingTransactionTypeWidgetData = WidgetFactory.createWidgetEntityData(
            'bm.customer.billing.transaction.type.details.widget.data',
            'Kundentransaktionsart',
            'bm.CustomerBillingTransactionType',
            this.customerBillingTransactionTypeId
        );
        this.initialized = true;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.initialized) {
            return;
        }
        if (changes['customerBillingTransactionTypeId']) {
            this.refreshComponent();
        }
    }

    ngOnDestroy(): void {
    }
}
